// extracted by mini-css-extract-plugin
module.exports = {"container":"LocalsTab_container__2cmLx"};